<template>
  <section class="flex flex-col gap-4">
    <span class="line gap-x-2 text-sm italic font-bold">
      {{ selectedSourceService.name_format }}

      <rpm-button
          icon="fa-solid fa-pen-to-square"
          color="transparent"
          tooltip-text="editar"
          @click="sourceServiceModalOpen = true"
      />
    </span>

    <section class="grid grid-cols-[auto_1fr] gap-8 w-full">
      <card padding="" class="flex flex-col h-fit sticky top-0">
        <div class="border-b border-gray-400/50 px-8 py-4">
          <span
              class="flex flex-row gap-4 justify-between items-center text-xl font-bold"
          >
            Procedimentos

            <rpm-button
                icon="fa-solid fa-plus"
                font-class="text-sm"
                class="h-6 w-6 rounded-md"
                tooltip-text="adicionar"
                @click="
                sourceProcedureModalTitle = 'Criar Procedimento';
                modalNoOrganization = false;
                openModal({}, 'modalSourceProcedure', 'sourceProcedureModalOpen');
              "
            />
          </span>
        </div>

        <rpm-time-line
            :data="procedures"
            v-slot="{ item: procedure, index }"
            class="px-8 py-8"
            :actual="actual"
        >
          <section class="flex flex-col gap-1 mb-4">
            <div class="flex flex-row gap-2 justify-between">
              <span
                  class="font-semibold w-fit transition-all"
                  :class="[
                  canSee(procedure)
                    ? 'cursor-pointer'
                    : 'cursor-not-allowed opacity-60',
                  hoveredProcedure === procedure.id
                    ? 'underline decoration-2 decoration-theme'
                    : '',
                  selectedSourceProcedure &&
                  selectedSourceProcedure.id == procedure.id
                    ? 'text-theme'
                    : ''
                ]"
                  @mouseover="hoverProcedure(procedure.id)"
                  @mouseleave="hoverProcedure(null)"
                  @click="handleSelectProcedure(procedure, index)"
              >
                {{ procedure.name }}
              </span>

              <rpm-button
                  v-if="canEdit(procedure)"
                  color="red-hover"
                  tooltip-text="excluir"
                  font-class="text-xs"
                  icon="fa-solid fa-trash"
                  class="h-6 w-6 rounded-md"
                  @click="openRemoveProcedureModal(procedure.id)"
              />
            </div>

            <ul
                class="ml-4 list-disc list-outside text-sm tracking-wide flex flex-col gap-1.5"
            >
              <li
                  v-for="situation in filterSituations(procedure)"
                  :key="situation.id"
              >
                <div class="inline-flex flex-wrap gap-x-2">
                  <span>
                    {{ situation.source_situation.description }}
                  </span>

                  <template v-if="situation.next_source_procedure">
                    <i class="fa-solid fa-link"></i>
                    <span
                        class="transition-all font-light"
                        :class="[
                        canSeeById(situation.next_source_procedure.id)
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed opacity-60',
                        hoveredProcedure === situation.next_source_procedure.id
                          ? 'underline decoration-2 decoration-theme'
                          : ''
                      ]"
                        @mouseover="
                        hoverProcedure(situation.next_source_procedure.id)
                      "
                        @mouseleave="hoverProcedure(null)"
                        @click="
                        handleSelectNextProcedure(
                          situation.next_source_procedure.id
                        )
                      "
                    >
                      {{ situation.next_source_procedure.name }}
                    </span>
                  </template>
                </div>
              </li>
            </ul>
          </section>
        </rpm-time-line>
      </card>

      <show-procedure
          v-if="selectedSourceProcedure && canSee(selectedSourceProcedure)"
          :key="selectedSourceProcedure?.id"
          :source-procedure="selectedSourceProcedure"
          :can-edit="canEdit(selectedSourceProcedure)"
          :can-execute="canExecute(selectedSourceProcedure)"
          :can-see="canSee(selectedSourceProcedure)"
          @open-procedure-modal="onOpenProcedureModal"
          @open-edit-situation-modal="onOpenEditSituationModal"
          @open-create-situation-modal="onOpenCreateSituationModal"
          @open-edit-organization-modal="onOpenEditOrganizationModal"
          @open-create-organization-modal="onOpenCreateOrganizationModal"
          @all-questionnaires-deleted="handleAllQuestionnairesDeletedFromChild"
      />
    </section>
  </section>

  <!-- MODAL ADD SITUAÇÃO VIA COMPONENTE -->
  <rpm-modal
      :open="openModalAddSourceSituation"
      :header="sourceSituationModalTitle"
      class="grid grid-cols-12 gap-x-6 gap-y-8"
  >
    <add-source-situation
        :source-situations="sourceSituations"
        :available-source-procedures="availableSourceProcedures"
        :source-procedure="selectedSourceProcedure"
        @close="openModalAddSourceSituation = $event"
        @situation-added="
        situationAddedOrUpdated();
        openModalAddSourceSituation = !$event;
      "
    />
  </rpm-modal>

  <!-- MODAL PROCEDIMENTO -->
  <rpm-modal
      :header="sourceProcedureModalTitle"
      class="grid grid-cols-12 gap-x-6 gap-y-8"
      :open="sourceProcedureModalOpen"
      persist
  >
    <rpm-input
        class="col-span-6"
        label="Nome"
        placeholder="Nome"
        required
        v-model="modalSourceProcedure.name"
        :errors="errors.name"
    />

    <rpm-input
        type="number"
        positive
        post="em dias"
        class="col-span-6"
        label="Prazo de Execução"
        placeholder="1,2,3 dias..."
        required
        v-model="modalSourceProcedure.execution_deadline"
        :errors="errors.execution_deadline"
    />

    <rpm-input
        v-if="!modalNoOrganization"
        type="select"
        class="col-span-10"
        label="Organização Executora"
        required
        :options="organizations"
        optionValue="id"
        optionLabel="name"
        v-model="selectedExecutorOrganization.id"
        :errors="errors.organizations || errors.organization_id || errors.id"
    />

    <rpm-input
        v-if="!modalNoOrganization"
        type="switch"
        label="Requer Responsável"
        class="col-span-2 items-center"
        required
        v-model="selectedExecutorOrganization.required_owner"
        :errors="errors.required_owner"
    />

    <rpm-input
        class="col-span-12"
        label="Descrição"
        placeholder="Descrição"
        type="editor"
        required
        v-model="modalSourceProcedure.description"
        :errors="errors.description"
    />

    <rpm-input
        type="switch"
        label="Solicitante pode executar"
        class="col-span-3 items-center"
        required
        v-model="modalSourceProcedure.enable_owner_execution"
        :errors="errors.enable_owner_execution"
    />

    <rpm-input
        type="switch"
        label="Ativo"
        class="col-span-3 items-center"
        required
        v-model="modalSourceProcedure.enabled"
        :errors="errors.enabled"
    />

    <rpm-input
        type="switch"
        label="Procedimento interno"
        class="col-span-3 items-center"
        required
        v-model="modalSourceProcedure.internal_procedure"
        :errors="errors.internal_procedure"
    />

    <rpm-input
        type="switch"
        label="Notificar o procedimento?"
        class="col-span-3 items-center"
        required
        v-model="modalSourceProcedure.allow_notification"
        :errors="errors.allow_notification"
    />

    <div class="flex flex-row justify-center gap-6 col-span-12 mt-4">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="sourceProcedureModalOpen = false"
      />
      <rpm-button label="Confirmar" @click="saveProcedure"/>
    </div>
  </rpm-modal>

  <rpm-modal
      :header="sourceSituationModalTitle"
      class="grid grid-cols-12 gap-x-6 gap-y-8"
      :open="sourceSituationModalOpen"
      persist
  >
    <rpm-input
        class="col-span-12"
        label="Situação"
        placeholder="Situação"
        type="select"
        required
        :options="sourceSituations"
        optionValue="id"
        optionLabel="name"
        v-model="modalSourceSituation.source_situation.id"
    />

    <rpm-input
        class="col-span-4"
        label="Próximo Procedimento"
        placeholder="Próximo Procedimento"
        type="select"
        optional
        optionValue="id"
        optionLabel="name"
        :options="availableSourceProcedures"
        v-model="nextSourceProcedureId"
    />

    <rpm-input
        class="col-span-4"
        label="Próxima Organização"
        placeholder="Próxima Organização"
        type="multiselect"
        optional
        :options="availableNextOrganizations"
        optionValue="organization_id"
        optionLabel="organization_name"
        v-model="modalSourceSituation.source_procedure_situation_organization"
    />

    <rpm-input
        class="col-span-4"
        label="Status"
        placeholder="Selecione um Status"
        type="select"
        :options="statusOptions"
        optionValue="id"
        optionLabel="label"
        v-model="modalSourceSituation.service_status_id"
        required
    />

    <rpm-input
        type="switch"
        label="Requer Observação"
        class="col-span-6 items-center"
        v-model="modalSourceSituation.observation_required"
    />
    <rpm-input
        type="switch"
        label="Habilitado"
        class="col-span-6 items-center"
        v-model="modalSourceSituation.enabled"
    />

    <div class="flex flex-row justify-center gap-6 col-span-12 mt-4">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="sourceSituationModalOpen = false"
      />
      <rpm-button
          label="Confirmar"
          @click="saveSourceProcedureSituation"
      />
    </div>
  </rpm-modal>

  <!-- MODAL ORGANIZAÇÃO / PERMISSÕES -->
  <rpm-modal
      :header="organizationModalTitle"
      class="grid grid-cols-12 gap-x-6 gap-y-8"
      :open="organizationModalOpen"
      persist
  >
    <rpm-input
        class="col-span-6"
        label="Organização"
        placeholder="Organização"
        type="select"
        required
        :options="organizations"
        optionValue="id"
        optionLabel="name"
        v-model="selectedExecutorOrganization.id"
        :errors="errors.organization_id"
    />

    <rpm-input
        type="switch"
        label="Requer Responsável"
        class="col-span-6 items-center"
        v-model="selectedExecutorOrganization.required_owner"
        :errors="errors.required_owner"
    />

    <rpm-input
        type="switch"
        label="Pode visualizar"
        class="col-span-4 items-center"
        v-model="permissionFlags.see"
        :errors="errors.actions"
    />
    <rpm-input
        type="switch"
        label="Pode executar"
        class="col-span-4 items-center"
        v-model="permissionFlags.execute"
    />
    <rpm-input
        type="switch"
        label="Pode editar"
        class="col-span-4 items-center"
        v-model="permissionFlags.edit"
    />

    <div class="col-span-12 text-xs text-gray-500 leading-5">
      <p>
        <b>Pode Visualizar</b> = ação <i>Ver</i> (slug:
        <code>see</code> / <code>ver</code>)
      </p>
      <p>
        <b>Pode Executar</b> = ação <i>Executar</i> (slug:
        <code>execute</code> / <code>executar</code>)
      </p>
      <p>
        <b>Pode Editar</b> = ação <i>Editar</i> (slug:
        <code>edit</code> / <code>editar</code>)
      </p>
    </div>

    <div class="flex flex-row justify-center gap-6 col-span-12 mt-4">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="organizationModalOpen = false"
      />
      <rpm-button
          label="Confirmar"
          :loading="loading"
          @click="saveProcedureOrganization"
      />
    </div>
  </rpm-modal>

  <!-- MODAL REMOVER PROCEDIMENTO -->
  <rpm-modal
      header="Remover Procedimento"
      :open="removeSourceProcedureModalOpen"
      @close="
      removeSourceProcedureModalOpen = false;
      selectedIdforExlcusion = null;
    "
      size="max-w-xl"
  >
    <template #buttons>
      <rpm-button
          color="red"
          label="Remover"
          @click="removeSourceProcedure"
      />
    </template>
  </rpm-modal>

  <CreateSourceServiceModal
      :open="sourceServiceModalOpen"
      @close="sourceServiceModalOpen = false"
      :form="selectedSourceService"
      :errors="errors"
      @submit="updateSourceService"
  />
</template>
<script>
import RpmModal from "#components/RpmModal.vue";
import CreateSourceServiceModal from "../modals/create.vue";
import RpmTimeLine from "#components/RpmTimeLine.vue";
import showProcedure from "./showProcedure.vue";

import sourceServiceRepository from "#repositories/sourceServiceRepository";
import organizationsRepository from "#repositories/organizationsRepository";
import sourceProcedureRepository from "#repositories/sourceProcedureRepository";
import sourceSituationStore from "#repositories/sourceSituationRepository";
import sourceProcedureSituationStore from "#repositories/sourceProcedureSituationRepository";
import serviceStatusRepository from "#repositories/serviceStatusRepository";
import sourceServiceProcedureOrganizationRepository from "#repositories/sourceServiceProcedureOrganizationRepository";

import _ from "lodash";
import {getErrors} from "#functions/validator";
import AddSourceSituation from "#views/service/source/modals/addSourceSituation.vue";
import RpmButton from "../../../../components/RpmButton/index.vue";
import RpmInput from "../../../../components/RpmInput/index.vue";

const PERMISSIONS = {
  1: "see",
  2: "execute",
  3: "edit",
};

export default {
  name: "ShowService",
  components: {
    RpmInput,
    RpmButton,
    RpmTimeLine,
    RpmModal,
    showProcedure,
    CreateSourceServiceModal,
    AddSourceSituation,
  },
  data() {
    return {
      errors: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {},
      },
      actual: null,

      sourceServiceModalOpen: false,
      sourceProcedureModalOpen: false,
      sourceSituationModalOpen: false,
      organizationModalOpen: false,
      removeSourceProcedureModalOpen: false,

      selectedIdforExlcusion: null,
      selectedSourceService: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {},
      },
      modalSourceProcedure: {},
      sourceProcedureModalTitle: "Criar Procedimento",
      sourceSituationModalTitle: "Adicionar Situação",
      organizationModalTitle: "Adicionar Organização",
      modalNoOrganization: false,
      modalSourceSituation: {},
      modalOrganization: {},

      selectedSourceProcedure: null,
      hoveredProcedure: null,
      procedures: [],
      organizations: [],

      selectedExecutorOrganization: {
        id: null,
        name: "",
        required_owner: false,
      },
      loading: false,

      permissionFlags: {
        see: false,
        execute: false,
        edit: false,
      },

      tempOrganizations: [],
      organization: {},
      sourceSituations: [],
      availableSourceProcedures: [],
      availableNextOrganizations: [],
      statusOptions: [],
      openModalAddSourceSituation: false,
    };
  },

  methods: {
    getActions(obj) {
      return obj?.actions || obj?.source_procedure?.actions || {};
    },

    canSee(obj) {
      return !!this.getActions(obj).see;
    },

    canEdit(obj) {
      return !!this.getActions(obj).edit;
    },

    canExecute(obj) {
      return !!this.getActions(obj).execute;
    },

    canSeeById(procId) {
      const p = this.procedures.find((x) => x.id === procId) || {};
      return this.canSee(p);
    },

    //---------------------------------------------------------------------
    // PERMISSÕES
    //---------------------------------------------------------------------


    resetPermissionFlags() {
      this.permissionFlags = {
        see: false,
        execute: false,
        edit: false,
      };
    },

    applyFlagsFromActionsArray(actions = []) {
      this.resetPermissionFlags();

      if (!Array.isArray(actions)) return;
      actions.forEach((action) => {
        let flag = PERMISSIONS[action.id];
        if (flag) this.permissionFlags[flag] = true;
      })
    },

    buildActionsArrayFromFlags() {
      const list = [];

      if (this.permissionFlags.see) list.push(1);
      if (this.permissionFlags.execute) list.push(2);
      if (this.permissionFlags.edit) list.push(3);

      return list;
    },

    async loadOrgPermissionsFromProcedure(orgId) {
      if (!this.selectedSourceProcedure?.id || !orgId) return;

      try {
        let data =
            await sourceServiceProcedureOrganizationRepository.findByOrganizationIdAndSourceProcedureId({
              organization_id: orgId,
              source_procedure_id: this.selectedSourceProcedure.id,
            });

        const spo = data?.source_procedure_organization || data || {};

        this.applyFlagsFromActionsArray(spo.actions || []);
        this.selectedExecutorOrganization.required_owner = !!spo.required_owner;

      } catch (e) {
        this.resetPermissionFlags();
        this.selectedExecutorOrganization.required_owner = false;
      }
    },

    //---------------------------------------------------------------------
    // INTERAÇÃO
    //---------------------------------------------------------------------

    handleSelectProcedure(procedure, index) {
      if (!this.canSee(procedure)) {
        this.$notify("Você não tem permissão para ver este procedimento.", "error");
        return;
      }
      this.selectedSourceProcedure = procedure;
      this.actual = index;
    },

    handleSelectNextProcedure(nextId) {
      const i = this.procedures.findIndex((obj) => obj.id === nextId);
      if (i < 0) return;

      const nextProc = this.procedures[i];

      if (!this.canSee(nextProc)) {
        this.$notify("Você não tem permissão para ver o procedimento de destino.", "error");
        return;
      }

      this.actual = i;
      this.selectedSourceProcedure = nextProc;
    },

    //---------------------------------------------------------------------
    // ABERTURA DE MODAIS
    //---------------------------------------------------------------------

    onOpenProcedureModal(evt) {
      if (!this.canEdit(this.selectedSourceProcedure)) {
        this.$notify("Você não tem permissão para editar este procedimento.", "error");
        return;
      }

      this.sourceProcedureModalTitle = "Atualizar Procedimento";
      this.modalNoOrganization = true;
      this.openModal(evt, "modalSourceProcedure", "sourceProcedureModalOpen");
    },

    onOpenEditSituationModal(evt) {
      if (!this.canEdit(this.selectedSourceProcedure)) {
        this.$notify("Você não tem permissão para editar esta situação.", "error");
        return;
      }

      this.sourceSituationModalTitle = "Atualizar Situação";
      this.openModal(evt, "modalSourceSituation", "sourceSituationModalOpen");
    },

    onOpenCreateSituationModal(flag) {
      if (!this.canEdit(this.selectedSourceProcedure)) {
        this.$notify("Você não tem permissão para adicionar situação.", "error");
        return;
      }

      this.sourceSituationModalTitle = "Adicionar Situação";
      this.openModalAddSourceSituation = flag;
    },

    onOpenEditOrganizationModal(evt) {
      if (!this.canEdit(this.selectedSourceProcedure)) {
        this.$notify("Você não tem permissão para editar organização.", "error");
        return;
      }

      this.organizationModalTitle = "Atualizar Organização";
      this.openModal(evt, "modalOrganization", "organizationModalOpen");
    },

    onOpenCreateOrganizationModal() {
      if (!this.canEdit(this.selectedSourceProcedure)) {
        this.$notify("Você não tem permissão para adicionar organização.", "error");
        return;
      }

      this.organizationModalTitle = "Adicionar Organização";
      this.openModal({}, "modalOrganization", "organizationModalOpen");
    },

    hoverProcedure(id) {
      this.hoveredProcedure = id;
    },

    async openModal(payload, obj, modal) {
      if (modal === "organizationModalOpen") {

        const orgId = payload?.organization_id ?? payload?.id ?? null;

        let orgName =
            payload?.organization_name ||
            payload?.name ||
            (payload?.organization && payload.organization.name) ||
            "";

        if (orgId && !orgName && this.organizations.length) {
          const found = this.organizations.find((o) => o.id === orgId);
          if (found) orgName = found.name;
        }

        if (!orgId) {
          this.selectedExecutorOrganization = {
            id: null,
            name: "",
            required_owner: false,
          };

          this.resetPermissionFlags();
        } else {
          this.selectedExecutorOrganization = {
            id: orgId,
            name: orgName,
            required_owner: false,
          };

          this.resetPermissionFlags();

          await this.loadOrgPermissionsFromProcedure(orgId);
        }
      }

      if (obj && typeof obj === "string") {
        this[obj] = payload;
      }

      this[modal] = true;
    },

    //---------------------------------------------------------------------
    // CRUD
    //---------------------------------------------------------------------

    async fetchOrganizations() {
      this.organizations = (await organizationsRepository.getOrganizations()).data;
    },

    async saveProcedure() {
      this.errors = {};
      this.loading = true;

      this.modalSourceProcedure.source_service_id = this.selectedSourceService.id;

      if (!this.modalSourceProcedure.id) {
        const organizations = this.selectedExecutorOrganization.id
            ? [{
              id: this.selectedExecutorOrganization.id,
              required_owner: !!this.selectedExecutorOrganization.required_owner,
            }]
            : [];

        sourceProcedureRepository
            .storeSourceProcedure({...this.modalSourceProcedure, organizations})
            .then(() => {
              this.$notify("Procedimento criado com sucesso", "success");
              this.selectedExecutorOrganization = {id: null, name: "", required_owner: false};
              this.sourceProcedureModalOpen = false;
              this.fetchSourceProcedures();
            })
            .catch((response) => {
              this.$notify("Erro ao criar o procedimento", "error");
              getErrors(this.errors, response.errors);
            })
            .finally(() => {
              this.loading = false;
            });
      } else {
        sourceProcedureRepository
            .updateSourceProcedure(
                this.modalSourceProcedure.id,
                _.omit(this.modalSourceProcedure, "organizations")
            )
            .then(() => {
              this.$notify("Procedimento atualizado com sucesso", "success");
              this.sourceProcedureModalOpen = false;
              this.fetchSourceProcedures();
            })
            .catch((response) => {
              this.$notify("Erro ao atualizar o procedimento", "error");
              getErrors(this.errors, response.errors);
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },

    //---------------------------------------------------------------------
    // SALVAR PERMISSÕES (FINAL)
    //---------------------------------------------------------------------

    async saveProcedureOrganization() {
      try {
        this.errors = {};
        this.loading = true;

        if (!this.selectedSourceProcedure?.id) {
          this.$notify("Selecione um procedimento antes de adicionar a organização.", "error");
          return;
        }

        const actions = this.buildActionsArrayFromFlags();

        const payload = {
          organization_id: this.selectedExecutorOrganization.id,
          required_owner: !!this.selectedExecutorOrganization.required_owner,
          actions
        };

        await sourceServiceProcedureOrganizationRepository.updateSourceProcedureOrganization(
            this.selectedSourceProcedure.id,
            payload
        );

        this.$notify("Organização e permissões salvas com sucesso", "success");
        this.organizationModalOpen = false;

        await this.fetchSourceProcedures();
        this.selectedSourceProcedure =
            (await sourceProcedureRepository.showSourceProcedure(this.selectedSourceProcedure.id)).data;

      } catch (err) {
        const respErrors = err?.response?.errors || err?.errors || {};
        getErrors(this.errors, respErrors);
        this.$notify("Erro ao salvar a organização/permissões", "error");
      } finally {
        this.loading = false;
      }
    },

    //---------------------------------------------------------------------

    async showSourceService() {
      this.selectedSourceService =
          (await sourceServiceRepository.showSourceService(this.$route.params.id)).data;
      this.selectedSourceProcedure = this.selectedSourceService.initial_source_procedure;
    },

    async fetchSourceProcedures() {
      this.procedures =
          (await sourceServiceRepository.getSourceProcedures(this.$route.params.id)).data;
    },

    async fetchSourceSituations() {
      this.sourceSituations =
          (await sourceSituationStore.getSourceSituations()).data;
    },

    async situationAddedOrUpdated() {
      await this.showSourceService();

      this.selectedSourceProcedure =
          (await sourceProcedureRepository.showSourceProcedure(
              this.selectedSourceProcedure.id
          )).data;

      await this.fetchSourceProcedures();
    },

    async saveSourceProcedureSituation() {
      this.loading = true;
      try {
        this.modalSourceSituation.source_procedure_id = this.selectedSourceProcedure.id;
        this.modalSourceSituation.next_organizations =
            this.modalSourceSituation.source_procedure_situation_organization;

        await sourceProcedureSituationStore.updateSourceProcedureSituation(
            this.modalSourceSituation.id,
            this.modalSourceSituation
        );

        await this.situationAddedOrUpdated();
        this.$notify("Situação atualizada com sucesso", "success");

      } catch (error) {
        this.errors = (error.response && error.response.errors) || {};
        this.$notify("Erro ao atualizar situação", "error");

      } finally {
        this.loading = false;
        this.sourceSituationModalOpen = false;
      }
    },

    filterSituations(procedure) {
      return _.filter(procedure.situations, (element) => element.enabled);
    },

    openRemoveProcedureModal(id) {
      this.selectedIdforExlcusion = id;
      this.removeSourceProcedureModalOpen = true;
    },

    removeSourceProcedure() {
      sourceProcedureRepository
          .removeSourceProcedure(this.selectedIdforExlcusion)
          .then(() => {
            this.fetchSourceProcedures();
            this.$notify("Procedimento removido com sucesso", "success");
            this.removeSourceProcedureModalOpen = false;
          })
          .catch((response) => {
            this.$notify(response.message, "error");
          });
    },

    updateSourceService() {
      this.errors = {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {},
      };
      this.loading = true;

      sourceServiceRepository
          .updateSourceService(this.selectedSourceService.id, this.selectedSourceService)
          .then(() => {
            this.$notify("Serviço modificado com sucesso", "success");
            this.sourceServiceModalOpen = false;
          })
          .catch((response) => {
            this.$notify("Erro ao modificar o serviço", "error");
            getErrors(this.errors, response.errors);
          })
          .finally(() => {
            this.loading = false;
            this.showSourceService();
          });
    },

    async fetchStatuses() {
      try {
        const response = await serviceStatusRepository.getAllStatuses();
        this.statusOptions = response.data || [];
      } catch {
        this.statusOptions = [];
      }
    },

    handleAllQuestionnairesDeletedFromChild() {
    },
  },

  async mounted() {
    await this.showSourceService();
    await this.fetchSourceProcedures();
    await this.fetchOrganizations();
    await this.fetchSourceSituations();
    await this.fetchStatuses();
  },

  computed: {
    nextSourceProcedureId: {
      get() {
        return this.modalSourceSituation.next_source_procedure?.id || null;
      },
      set(value) {
        if (!this.modalSourceSituation.next_source_procedure) {
          this.modalSourceSituation.next_source_procedure = {};
        }
        this.modalSourceSituation.next_source_procedure.id = value;
      },
    },
  },

  watch: {
    "selectedExecutorOrganization.id"(val) {
      if (val && !this.modalNoOrganization) {
        const organization = _.find(this.organizations, {id: val});
        if (organization) {
          this.selectedExecutorOrganization.id = organization.id;
          this.selectedExecutorOrganization.name = organization.name;
        }
      }
    },

    selectedSourceProcedure() {
      this.modalSourceProcedure = this.selectedSourceProcedure;
      this.availableSourceProcedures = _.reject(
          this.procedures,
          (el) => el.id === this.selectedSourceProcedure.id
      );
    },

    async "modalSourceSituation.next_source_procedure.id"(val) {
      if (val) {
        this.availableNextOrganizations =
            (await sourceProcedureSituationStore.fetchNextSourceProcedureOrganizations(val)).data;
      }
    },
  },
};
</script>
